<template>

  <div>
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ $t('Control') }}</strong>
    </div>
    <div class="card-body" v-if="editable">

      <form v-on:submit.prevent="save(candidateEdit)">
        <div class="form-group">
          <label>{{ $t('Source') }}</label>
          <select-source
            v-model="candidateEdit.source_id">
            </select-source>
          <ValidateMessage :error="validateErrors.source_id" />
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>

    </div>

    <div
      v-if="!editable"
      class="card-body">

      <div class="row mb-2">
        <div class="col-sm-3">
          <strong>{{ $t('Created at') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ candidate.created_at | moment('fromNow', $i18n.locale) }}
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-sm-3">
          <strong>{{ $t('Origin') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ getOriginName }}
        </div>
      </div>

      <div
        v-if="editMode || candidate.source_id"
        class="row mb-2">
        <div class="col-sm-3">
          <strong>{{ $t('Source') }}</strong>
        </div>
        <div class="col-sm-8">
          {{ candidate.source_id ? candidate.source_id.name : '--' }}
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import _ from 'lodash'
import SelectSource from '@/components/Fields/SelectSource'

export default {
  name: 'CandidateProfileDetails',
  components: {
    SelectSource
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    resources () {
      return this.$store.getters.getResources
    },
    getOriginName () {
      return {
        'sourced': 'Prospect',
        'referred': this.$t('Recommendation'),
        'applied': this.$t('Application'),
        'internal_applied': this.$t('Internal application')
      }[this.candidate.origin] || 'N/D'
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = _.pick(this.candidate, [
        '_id',
        'source_id'
      ])
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileControl.vue